import React from 'react';
import { Form, Input, Row, Col, Button } from 'antd';
import SitemapChangeFreqInput from '../../components/SitemapChangeFreqInput.js';
import Editor from 'for-editor'
const EditorToolbar = {
  h1: false, 
  h2: true, 
  h3: true, 
  h4: true, 
  h5: true, 
  img: false, 
  link: true, 
  code: false, 
  preview: true, 
  expand: true, 
  /* v0.0.9 */
  undo: true, 
  redo: true, 
  save: false, 
  /* v0.2.3 */
  subfield: true,
}
const FormItem = Form.Item;

function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class CategoryForm extends React.Component {
    constructor() {
        super();
        this.state = {
            title:null,
            meta_title:null,
            meta_description: null,
            url: null,
            slug: null,
            description: null,
            parent_id: 1,
        }
    }

    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, fieldsValue) => {
            if (err) {
                return;
            }
            this.props.submit(Object.assign({}, fieldsValue, {parent_id: this.state.parent_id}));
        });
    }

    render() {
        const formItemLayout = {
            labelCol: {
            xs: { span: 24 },
            sm: { span: 24 },
            },
            wrapperCol: {
            xs: { span: 24 },
            sm: { span: 24 },
            },
        };
        const { getFieldDecorator, getFieldsError } = this.props.form;
        return (
            <div style={{direction: 'rtl'}}>
            <Form onSubmit={this.handleSubmit}>
                <Row>
                    <Col span={20} offset={2}>
                        <FormItem
                        {...formItemLayout}
                        label="عنوان"
                        colon={false}>
                            {getFieldDecorator('title', {
                                initialValue: this.props.initialData.name,
                                rules: [
                                ],
                            })(
                                <Input style={{direction:'rtl'}} disabled />
                            )}
                        </FormItem>

                        <FormItem
                        {...formItemLayout}
                        label="URL"
                        colon={false}>
                            {getFieldDecorator('url', {
                                initialValue: this.props.initialData.url,
                                rules: [
                                ],
                            })(
                                <Input disabled />
                            )}
                        </FormItem>

                        <FormItem
                        {...formItemLayout}
                        label="اسلاگ"
                        colon={false}>
                            {getFieldDecorator('slug', {
                                initialValue: this.props.initialData.slug,
                                rules: [
                                ],
                            })(
                                <Input disabled />
                            )}
                        </FormItem>

                        <FormItem
                        {...formItemLayout}
                        label="متا تایتل"
                        colon={false}>
                            {getFieldDecorator('meta_title', {
                                initialValue: this.props.initialData.meta_title,
                                rules: [
                                    {required: true, message: 'متا تایتل را وارد نمایید'}
                                ],
                            })(
                                <Input style={{direction:'rtl'}} />
                            )}
                        </FormItem>

                        <FormItem
                        {...formItemLayout}
                        label="متا دسکریپشن"
                        colon={false}>
                            {getFieldDecorator('meta_description', {
                                initialValue: this.props.initialData.meta_description,
                                rules: [
                                    {required: true, message: 'متا دسکریپشن را وارد نمایید'}
                                ],
                            })(
                                <Input.TextArea style={{direction:'rtl'}} />
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="توضیحات(درباره دسته‌بندی)"
                            colon={false}>
                            {getFieldDecorator('description', {
                                initialValue: this.props.initialData.description,
                                rules: [],
                            })(
                                <Editor placeholder="توضیحات(درباره دسته‌بندی)" toolbar={EditorToolbar}/>
                            )}
                        </FormItem>
                        {SitemapChangeFreqInput(this.props.initialData.sitemap_change_freq, getFieldDecorator, formItemLayout)}

                        <FormItem
                            {...formItemLayout}
                            label="اولویت نقشه سایت"
                            colon={false}>
                            {getFieldDecorator('sitemap_priority', {
                                initialValue: this.props.initialData.sitemap_priority
                            })(
                                <Input />
                            )}
                        </FormItem>

                    </Col>
                </Row>
                <Row>
                <Col span={24}>
                    <FormItem>
                        <Button
                            type="primary"
                            htmlType="submit"
                            disabled={hasErrors(getFieldsError()) || this.props.submitted}
                            style={{width: '10%', margin: '0px 45%'}}>
{this.props.submitted ? 'منتظر بمانید' : ' ثبت'}
                        </Button>
                    </FormItem>
                </Col>
                </Row>
            </Form>
            </div>
        );
    }
}

CategoryForm.defaultProps = {
    initialData: {}
}

export default Form.create()(CategoryForm);


// WEBPACK FOOTER //
// ./src/containers/Categories/form.js